export const settingsKeys = {
  all: ['settings'] as const,
  lists: () => [...settingsKeys.all, 'list'] as const,
  list: () => [...settingsKeys.lists()] as const,
  details: () => [...settingsKeys.all, 'detail'] as const,
  detail: (id?: string) => [...settingsKeys.details(), id] as const,
  profilePicture: (filePath: string) => [...settingsKeys.details(), 'profile-picture', filePath] as const,
};
